<template>
  <div class="footer">
    <p class="p-rights">© TH Web 2023 - All Rights Reserved.</p>
    <div class="rights"></div>
    <div class="legal"></div>
    <p class="p-legal"><a href="#">Mentions légales</a></p>
  </div>
</template>

<script>
export default {
  name: 'FooterPage',
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  .rights {
    position: absolute;
    bottom: 0;
    border-right: 100vw solid transparent;
    border-bottom: 16vh solid var(--blue);
    z-index: 2;
  }

  .p-rights {
    position: absolute;
    bottom: 0vh;
    z-index: 1;
    font-size: 0.8em;
    margin-left: 10px;
    color: #e8e8e8;
    z-index: 3;
  }

  .legal {
    position: absolute;
    bottom: 0;
    border-left: 100vw solid transparent;
    border-bottom: 13vh solid var(--darkgrey);
    z-index: 0;
  }

  .p-legal {
    position: absolute;
    bottom: 3vh;
    right: 0;
    z-index: 1;
    font-size: 0.8em;
    margin-right: 10px;
  }

  .p-legal a {
    text-decoration: none;
    color: #e8e8e8;
  }

  .p-legal a:hover {
    color: #f29310;
    text-decoration: none;
  }
}
</style>
